export class CheckInVpvEventDto {
  event: string;
  event_params: CheckInVpvEventParamsDto;
  user_properties?: CheckInUserPropertiesDto;
}

export class CheckInVpvEventParamsDto {
  micrositio: string;
  page_path: string;
  page_type: string;
  page_title: string;
  homemarket: string;
  product_name: string;
  environment: string;
  login: boolean;
}

export class CheckInUserPropertiesDto {
  pas_dni_hashed: string;
  birthday?: string;
  user_type: string;
}

export interface VpvEventInput {
  micrositio: string;
  page_path: string;
  page_type: string;
  page_title: string;
  homemarket: string;
  environment: string;
  product_name: string;
  login: boolean;
  user_props?: {
    pas_dni?: string;
    birthday?: string;
    user_type?: string;
  };
}
